// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"c56bc111","892":"50e98a24"}[chunkId] + ".chunk.js";
};